import { render, staticRenderFns, recyclableRender, components } from "./points.vue?vue&type=template&id=5c78a632&scoped=true&"
var renderjs
import script from "./points.vue?vue&type=script&lang=js&"
export * from "./points.vue?vue&type=script&lang=js&"
import style0 from "./points.vue?vue&type=style&index=0&id=5c78a632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c78a632",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/store/part/user/points.vue"
export default component.exports